import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
})
export class AppComponent {
    private _authService = inject(AuthService);

    /**
     * Constructor
     */
    constructor() {
        this._authService.watchForForeignTokenChanges();
    }
}
